import { initQuizSteps, setQuizStepsHeight } from './quiz-steps/quiz-steps';

setQuizStepsHeight();

document.addEventListener('DOMContentLoaded', () => {
  initQuizSteps();
});
